import EditTopicForm from '../EditTopicForm'

import type { SuggestedTopic } from 'types/topic'
import type { EditFormValues } from '../EditTopicForm'

type Props = {
  open: boolean
  onClose: () => void
  onSubmit: (values: EditFormValues) => void | Promise<void>
  isLoading?: boolean
  selectedTopic?: SuggestedTopic
}

export const EditProjectTopicModal: React.FC<Props> = ({
  open,
  onClose,
  onSubmit,
  isLoading,
  selectedTopic,
}) => {
  const initialValues = {
    name: selectedTopic?.name ?? '',
    primaryKeyword: selectedTopic?.keywords?.find(k => k.type === 'primary')
      ?.keyword,
    secondaryKeywords: selectedTopic?.keywords
      ?.filter(k => k.type === 'secondary')
      .map(k => k.keyword),
    shouldAttachSeoGuidelines: true,
  }

  return (
    <EditTopicForm
      open={open}
      onClose={onClose}
      initialValues={initialValues}
      onSubmit={onSubmit}
      isLoading={isLoading}
      isSuggestedTopic={true}
    />
  )
}
